module.exports = __webpack_public_path__ + "img/1.71.8f66e3ff.png";